<template>
  <div class="uk-offcanvas-content">
    <div class="uk-navbar-container uk-sticky uk-sticky-fixed" style="position: fixed; top: 0; width: 100%;">
      <div class="uk-container uk-container-expand">
        <nav class="uk-navbar">
          <div class="uk-navbar-left">
            <router-link :to="{ name: 'Index' }" class="uk-navbar-item uk-logo">
              <!--<img class="uk-margin-small-right" src="/templates/gruendel/icons/home.svg" width="40" height="40" uk-svg> B2B-->
              <img class="uk-margin-small-right" :src="logo" />
            </router-link>
            <div class="uk-navbar-left">
              <a class="uk-navbar-toggle uk-visible@m" @click="onSidebarToggle" href="#"
                uk-toggle="target: #sidebar; duration: 400; animation: uk-animation-slide-left">
                <div class="uk-flex uk-flex-middle">
                  <span data-uk-icon="icon:chevron-left;ratio: 0.7" v-if="!collapsed"></span><span
                    data-uk-icon="menu"></span>
                </div>
              </a>
              <template v-if="tenant.knumber === 'K10162'">
                <a href="#" @click.prevent="doTranslate('de|de')">
                  <img src="/img/lang/de.png" alt="Deutsch" class="uk-margin-small-right" />
                </a>
                <a href="#" @click.prevent="doTranslate('de|en')">
                  <img src="/img/lang/en.png" alt="Englisch" class="uk-margin-small-right" />
                </a>
                <a href="#" @click.prevent="doTranslate('de|it')">
                  <img src="/img/lang/it.png" alt="Italienisch" class="uk-margin-small-right" />
                </a>
              </template>
            </div>
          </div>

          <div class="uk-position-center" v-if="mode == 'endcustomer'">
            <a href="#" class="uk-button uk-button-primary uk-button-small uk-border-rounded"
              @click.prevent="switchCustomerType" v-text="customerTypeLabel"></a>
          </div>

          <div class="uk-navbar-right">
            <div class="uk-navbar-item uk-visible@m">
              <router-link :to="{ name: 'cart' }" class="uk-link-text" uk-icon="icon: cart; ratio: 1.6"
                v-if="showCart"></router-link>
              <span v-if="cartCount > 0" class="uk-badge uk-text-small" style="margin-top: -20px;margin-left: 2px;">{{
                cartCount
              }}</span>
              <div class="uk-navbar-item" v-if="tenant.knumber === 'K10122' || tenant.knumber === 'K10151'">
                <router-link :to="{ name: 'faq' }" class="uk-margin-left uk-button uk-button-link"
                  style="margin-top: -2px">Faq</router-link>
              </div>
              <div class="uk-navbar-item">
                <button class="uk-button uk-button-link uk-margin-left" type="button">
                  Benutzer<span class="uk-margin-small-left uk-icon" uk-icon="icon: chevron-down"></span>
                </button>
                <div uk-dropdown="mode: click">
                  <ul class="uk-nav uk-dropdown-nav">
                    <li>
                      <router-link class="uk-dropdown-close" :to="{ name: 'account' }">Mein Konto</router-link>
                    </li>
                    <li>
                      <router-link class="uk-dropdown-close" :to="{ name: 'orders' }">Meine Bestellungen</router-link>
                    </li>
                    <li class="uk-nav-divider"></li>
                    <li>
                      <a class="uk-dropdown-close" href="#" @click.prevent="logout()">Abmelden<span
                          class="uk-margin-small-left uk-icon" uk-icon="icon: sign-out"></span></a>
                    </li>
                  </ul>
                </div>
              </div>
              <button class="uk-button uk-margin-left uk-button-small uk-border-rounded" @click="switchMerchantMode"
                v-text="modeLabel"
                :class="{ 'uk-button-primary': mode === 'merchant', 'uk-button-danger': mode === 'endcustomer' }"></button>
            </div>
            <!--
                            <ul class="uk-navbar-nav uk-visible@m">
                                <li><a href="#" uk-icon="icon: world; ratio: 2"></a></li>
                            </ul>
                        -->

            <a class="uk-navbar-toggle uk-hidden@m" uk-navbar-toggle-icon href="#offcanvas" uk-toggle></a>
          </div>
        </nav>
      </div>
    </div>

    <div class="b2b-sidebar-left uk-visible@m" id="sidebar">
      <tabs>
        <tab name="vehicles" :selected="true" icon="list" :index="0" tooltip="Fahrzeuge">
          <ul class="uk-nav uk-nav-default uk-nav-parent-icon sidebar-nav" uk-nav>
            <li>
              <router-link to="/fahrzeuge"> Alle Fahrzeuge ({{ stats.vehicles }}) </router-link>
            </li>
            <li class="uk-parent" v-for="make in makes" :key="make.id">
              <a href="#">
                <img style="width: 40px;" :src="'/img/makes/' + make.value + '.png'" alt="" />
                {{ make.label }} ({{ make.count }})
              </a>
              <ul class="uk-nav-sub">
                <li>
                  <router-link :to="{ name: 'VehicleIndex', query: { make: make.value } }">Alle {{ make.label }} ({{
                    make.count
                  }})</router-link>
                </li>
                <li v-for="model in make.models" :key="model.id">
                  <ul v-if="model.group">
                    <li>
                      <router-link :to="{ name: 'VehicleIndex', query: { make: make.value, model: model.value } }">{{
                        model.label
                      }} ({{ model.count }})</router-link>
                    </li>
                  </ul>
                  <router-link v-else :to="{ name: 'VehicleIndex', query: { make: make.value, model: model.value } }">{{
                    model.label
                  }} ({{ modelCount(model, make.models) }})</router-link>
                </li>
              </ul>
            </li>
          </ul>
          <template v-if="tenant.knumber === 'K10151' && damagesStats && damagesMakes.length">
            <hr />
            <ul class="uk-nav uk-nav-default uk-nav-parent-icon sidebar-nav" uk-nav>
              <li>
                <router-link :to="{ name: 'VehicleIndex', query: { opendamagesMin: 2000 } }">
                  Fahrzeuge mit Schäden ({{ damagesStats.vehicles }})
                </router-link>
              </li>
              <li class="uk-parent" v-for="make in damagesMakes" :key="make.id">
                <a href="#">
                  <img style="width: 40px;" :src="'/img/makes/' + make.value + '.png'" alt="" />
                  {{ make.label }} ({{ make.count }})
                </a>
                <ul class="uk-nav-sub">
                  <li>
                    <router-link :to="{ name: 'VehicleIndex', query: { make: make.value, opendamagesMin: 2000 } }">Alle
                      {{ make.label }} ({{ make.count }})</router-link>
                  </li>
                  <li v-for="model in make.models" :key="model.id">
                    <ul v-if="model.group">
                      <li>
                        <router-link :to="{
                          name: 'VehicleIndex',
                          query: { make: make.value, model: model.value, opendamagesMin: 2000 }
                        }">{{ model.label }} ({{ model.count }})</router-link>
                      </li>
                    </ul>
                    <router-link v-else :to="{
                      name: 'VehicleIndex',
                      query: { make: make.value, model: model.value, opendamagesMin: 2000 }
                    }">{{ model.label }} ({{ modelCount(model, make.models) }})</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </template>
          <template v-if="tenant.knumber === 'K10151'">
            <hr />
            <router-link :to="{ name: 'exchange.index' }" class="uk-button uk-button-secondary uk-width-1-1 uk-flex uk-flex-middle">
              <span class="uk-margin-small-right uk-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                  <path d="M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                  <path d="M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"></path>
                  <path d="M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"></path>
                </svg>
              </span>
              <span>Restwertbörse</span>
            </router-link>
          </template>
          <div class="uk-margin" v-if="stats.packages > 0">
            <router-link :to="{ name: 'VehiclePackages' }" class="uk-button uk-button-secondary uk-width-1-1">
              Fahrzeugpakete
              <span data-uk-icon="arrow-right"></span>
            </router-link>
          </div>
        </tab>

        <tab name="documents" icon="album" :index="1" tooltip="Dokumente">
          <ul class="uk-nav uk-nav-default">
            <!--<li><a href="#"><span class="uk-margin-small-right uk-icon" uk-icon="icon: mail"></span>Lieferantenanfragen</a></li>-->
            <li>
              <router-link :to="{ name: 'offers' }"><span class="uk-margin-small-right uk-icon"
                  uk-icon="icon: file-pdf"></span>Angebote</router-link>
            </li>
            <!--<li><a href="#"><span class="uk-margin-small-right uk-icon" uk-icon="icon: clock"></span>Reservierungen</a></li>-->
            <li>
              <router-link :to="{ name: 'orders' }"><span class="uk-margin-small-right uk-icon"
                  uk-icon="icon: check"></span>Bestellungen</router-link>
            </li>
          </ul>
        </tab>
        <tab name="settings" icon="settings" :index="2" tooltip="Einstellungen">
          <ul class="uk-nav uk-nav-default">
            <li>
              <router-link :to="{ name: 'account' }"><span class="uk-margin-small-right uk-icon"
                  uk-icon="icon: user"></span>Mein Konto</router-link>
            </li>
            <!--<li><a href="#"><span class="uk-margin-small-right uk-icon" uk-icon="icon: users"></span>Ansprechpartner verwalten</a></liettings>-->
            <li v-if="$can('manage', 'company') || $can('manage', 'all')">
              <router-link :to="{ name: 'surcharge' }"><span class="uk-margin-small-right uk-icon"
                  uk-icon="icon: plus"></span>Preis-Aufschläge</router-link>
            </li>
            <li v-if="$can('manage', 'company') || $can('manage', 'all')">
              <router-link :to="{ name: 'view-settings' }"><span class="uk-margin-small-right uk-icon"
                  uk-icon="icon: paint-bucket"></span>Ansicht</router-link>
            </li>
          </ul>
        </tab>
        <tab name="admin" icon="cog" :index="3" tooltip="Admin" v-if="$store.state.auth.user.isAdmin">
          <ul class="uk-nav uk-nav-default">
            <li>
              <router-link :to="{ name: 'admin.dashboard' }">
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: desktop"></span>Dashboard
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'admin.merchant' }">
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: users"></span>Händler
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'admin.offers' }"><span class="uk-margin-small-right uk-icon"
                  uk-icon="icon: file-pdf"></span>Angebote</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'admin.orders' }">
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: cart"></span>Bestellungen
              </router-link>
            </li>
            <li v-if="$can('manage', 'company') || $can('manage', 'all')">
              <a href="#" @click.prevent="printVehicles('pdf')">
                <span class="uk-icon" uk-icon="icon: print" v-if="!printing"></span>
                <div v-else data-uk-spinner="ratio: 0.657"></div>
                <span class="uk-margin-small-left">Bestand drucken <small>(PDF)</small></span>
              </a>
            </li>
            <li v-if="$can('manage', 'company') || $can('manage', 'all')">
              <a href="#" @click.prevent="printVehicles('csv')">
                <span class="uk-icon" uk-icon="icon: print" v-if="!printing"></span>
                <div v-else data-uk-spinner="ratio: 0.657"></div>
                <span class="uk-margin-small-left">Bestand drucken <small>(CSV)</small></span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="printMerchants">
                <span class="uk-icon" uk-icon="icon: print" v-if="!printingMerchants"></span>
                <div v-else data-uk-spinner="ratio: 0.657"></div>
                <span class="uk-margin-small-left">Händlerliste drucken</span>
              </a>
            </li>
            <li>
              <router-link :to="{ name: 'admin.banner' }">
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: image"></span>Banner
              </router-link>
            </li>
            <li v-if="tenant.knumber === 'K10151' && ($can('manage', 'company') || $can('manage', 'all'))"
              :class="[$route.path.startsWith('/admin/exchange') ? 'uk-active' : '']">
              <router-link :to="{ name: 'admin.exchange.index' }">
                <span class="uk-margin-small-right uk-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                    <path d="M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                    <path d="M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"></path>
                    <path d="M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"></path>
                  </svg>
                </span>Restwertbörse
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'admin.settings' }">
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: settings"></span>Einstellungen
              </router-link>
            </li>
          </ul>
        </tab>
      </tabs>
    </div>

    <div class="b2b-main uk-section uk-section-small uk-section-muted uk-margin-xlarge-bottom">
      <div class="uk-container uk-container-large uk-position-relative">
        <router-view />
      </div>
    </div>

    <div id="offcanvas" uk-offcanvas="mode: push; overlay: true;">
      <div class="uk-offcanvas-bar">
        <div class="uk-panel">

          <div class="uk-width-1-2@s uk-width-2-5@m">
            <ul class="uk-nav-default" uk-nav>
              <li class="uk-parent">
                <a href="#">Fahrzeuge <span uk-nav-parent-icon></span></a>
                <ul class="uk-nav-sub" uk-nav>
                  <li>
                    <router-link to="/fahrzeuge"> Alle Fahrzeuge ({{ stats.vehicles }}) </router-link>
                  </li>
                  <li class="uk-parent" v-for="make in makes" :key="make.id">
                    <a href="#">
                      <img style="width: 40px;" :src="'/img/makes/' + make.value + '.png'" alt="" />
                      {{ make.label }} ({{ make.count }})
                    </a>
                    <ul class="uk-nav-sub">
                      <li>
                        <router-link :to="{ name: 'VehicleIndex', query: { make: make.value } }">Alle {{ make.label }}
                          ({{ make.count }})</router-link>
                      </li>
                      <li v-for="model in make.models" :key="model.id">
                        <ul v-if="model.group">
                          <li>
                            <router-link
                              :to="{ name: 'VehicleIndex', query: { make: make.value, model: model.value } }">{{
                                model.label
                              }} ({{ model.count }})</router-link>
                          </li>
                        </ul>
                        <router-link v-else
                          :to="{ name: 'VehicleIndex', query: { make: make.value, model: model.value } }">{{
                            model.label
                          }} ({{ modelCount(model, make.models) }})</router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="uk-parent">
                <a href="#">Dokumente <span uk-nav-parent-icon></span></a>
                <ul class="uk-nav-sub">
                  <li>
                    <router-link :to="{ name: 'offers' }"><span class="uk-margin-small-right uk-icon"
                        uk-icon="icon: file-pdf"></span>Angebote</router-link>
                  </li>
                  <!--<li><a href="#"><span class="uk-margin-small-right uk-icon" uk-icon="icon: clock"></span>Reservierungen</a></li>-->
                  <li>
                    <router-link :to="{ name: 'orders' }"><span class="uk-margin-small-right uk-icon"
                        uk-icon="icon: check"></span>Bestellungen</router-link>
                  </li>
                </ul>
              </li>
              <li class="uk-parent">
                <a href="#">Einstellungen <span uk-nav-parent-icon></span></a>
                <ul class="uk-nav-sub">
                  <li>
                    <router-link :to="{ name: 'account' }"><span class="uk-margin-small-right uk-icon"
                        uk-icon="icon: user"></span>Mein Konto</router-link>
                  </li>
                  <!--<li><a href="#"><span class="uk-margin-small-right uk-icon" uk-icon="icon: users"></span>Ansprechpartner verwalten</a></liettings>-->
                  <li v-if="$can('manage', 'company') || $can('manage', 'all')">
                    <router-link :to="{ name: 'surcharge' }"><span class="uk-margin-small-right uk-icon"
                        uk-icon="icon: plus"></span>Preis-Aufschläge</router-link>
                  </li>
                  <li v-if="$can('manage', 'company') || $can('manage', 'all')">
                    <router-link :to="{ name: 'view-settings' }"><span class="uk-margin-small-right uk-icon"
                        uk-icon="icon: paint-bucket"></span>Ansicht</router-link>
                  </li>
                </ul>
              </li>
              <li class="uk-parent" v-if="$store.state.auth.user.isAdmin">
                <a href="#">Admin <span uk-nav-parent-icon></span></a>
                <ul class="uk-nav-sub">
                  <li>
                    <router-link :to="{ name: 'admin.dashboard' }">
                      <span class="uk-margin-small-right uk-icon" uk-icon="icon: desktop"></span>Dashboard
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'admin.merchant' }">
                      <span class="uk-margin-small-right uk-icon" uk-icon="icon: users"></span>Händler
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'admin.offers' }"><span class="uk-margin-small-right uk-icon"
                        uk-icon="icon: file-pdf"></span>Angebote</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'admin.orders' }">
                      <span class="uk-margin-small-right uk-icon" uk-icon="icon: cart"></span>Bestellungen
                    </router-link>
                  </li>
                  <li v-if="$can('manage', 'company') || $can('manage', 'all')">
                    <a href="#" @click.prevent="printVehicles('pdf')">
                      <span class="uk-icon" uk-icon="icon: print" v-if="!printing"></span>
                      <div v-else data-uk-spinner="ratio: 0.657"></div>
                      <span class="uk-margin-small-left">Bestand drucken <small>(PDF)</small></span>
                    </a>
                  </li>
                  <li v-if="$can('manage', 'company') || $can('manage', 'all')">
                    <a href="#" @click.prevent="printVehicles('csv')">
                      <span class="uk-icon" uk-icon="icon: print" v-if="!printing"></span>
                      <div v-else data-uk-spinner="ratio: 0.657"></div>
                      <span class="uk-margin-small-left">Bestand drucken <small>(CSV)</small></span>
                    </a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="printMerchants">
                      <span class="uk-icon" uk-icon="icon: print" v-if="!printingMerchants"></span>
                      <div v-else data-uk-spinner="ratio: 0.657"></div>
                      <span class="uk-margin-small-left">Händlerliste drucken</span>
                    </a>
                  </li>
                  <li v-if="$can('manage', 'company') || $can('manage', 'all')">
                    <router-link :to="{ name: 'admin.banner' }">
                      <span class="uk-margin-small-right uk-icon" uk-icon="icon: image"></span>Banner
                    </router-link>
                  </li>
                  <li v-if="$can('manage', 'company') || $can('manage', 'all')">
                    <router-link :to="{ name: 'admin.exchange.index' }">
                      <span class="uk-margin-small-right uk-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                          stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round"
                          stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                          <path d="M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                          <path d="M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"></path>
                          <path d="M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"></path>
                        </svg>
                      </span>Restwertbörse
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'admin.settings' }">
                      <span class="uk-margin-small-right uk-icon" uk-icon="icon: settings"></span>Einstellungen
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <div class="uk-position-fixed uk-position-bottom" style="z-index: 999" v-if="tenant.company">
      <div class="uk-background-secondary uk-light uk-padding-small uk-panel uk-text-small">
        <div class="uk-align-left uk-margin-remove">
          <a class="uk-link-reset" href="#" @click.prevent="logout()"><span class="uk-margin-small-left uk-icon"
              uk-icon="icon: sign-out"></span></a>
        </div>

        <div class="uk-align-right@s">
          © {{ currentYear }}&nbsp; {{ tenant.company }} | {{ tenant.street }} | D-{{ tenant.zipcode }}
          {{ tenant.city }} &nbsp;|&nbsp;powered by
          <a class="uk-link-reset" href="https://www.ackermann-netsolution.de" target="_blank">ACKERMANN-netsolution</a>
        </div>
      </div>
    </div>
    <div class="scroll-info uk-visible@m">
      <ul>
        <li class="uk-flex uk-flex-middle">
          <a :href="'tel:' + tenant.phoneLink" class="uk-link-reset">
            <span data-uk-icon="receiver" class="uk-icon"></span>
            <span class="uk-text-bold">{{ tenant.phone }}</span>
          </a>
        </li>
        <li class="uk-flex uk-flex-middle">
          <a :href="'mailto:' + tenant.email" class="uk-link-reset">
            <span data-uk-icon="mail" class="uk-icon"></span>
            <span class="uk-text-bold">E-Mail</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Tabs from './../components/Tabs.vue'
import Tab from './../components/Tab.vue'
import VehicleService from '../services/vehicle.service'
import SaleService from '../services/sale.service'
import { mapGetters, mapActions } from 'vuex'
import Configuration from '@/configuration'
const baseURL = Configuration.value('apiBackend')
const frontendUrl = Configuration.value('apiUrl')
import axios from 'axios'
import { defineRulesFor } from '@/config/ability'

export default {
  components: {
    Tabs,
    Tab
  },

  data() {
    return {
      damagesMakes: [],
      damagesStats: null,
      collapsed: false,
      printing: false,
      printingMerchants: false
    }
  },

  created() {
    const user = this.$store.state.auth.user
    if (user.isAuthenticated) {
      this.$ability.update(defineRulesFor(user.data))
    }
  },

  mounted() {
    document.body.classList.add(`theme-${Configuration.value('client')}`)
    this.fetchTenant()
    if (Configuration.value('client') === 'fleetpool') {
      VehicleService.getMakes({ opendamagesMin: 2000 }).then(response => {
        this.damagesMakes = response.data
      })
      SaleService.getVehicleCount({ opendamagesMin: 2000 }).then(response => {
        this.damagesStats = response.data
      })
    }
    if (Configuration.value('client') === 'daleo') {
      //this.googleTranslateInit()
    }
    //set matomo siteId
    setTimeout(() => {
      this.setMatomoSiteId()
    }, 1000)
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      switchMerchantMode: 'switchMerchantMode',
      switchCustomerType: 'switchCustomerType',
      fetchTenant: 'auth/fetchTenant'
    }),
    onSidebarToggle() {
      const el = document.body
      if (!this.collapsed) {
        el.classList.add('sidebar-collapse')
      } else {
        el.classList.remove('sidebar-collapse')
      }
      this.collapsed = !this.collapsed
    },
    printVehicles(type) {
      this.printing = true
      axios({
        url: `${baseURL}/statistic/print-stock?type=${type}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Fahrzeugbestand.${type}`)
        document.body.appendChild(link)
        link.click()
        this.printing = false
      })
    },
    printMerchants() {
      this.printingMerchants = true
      axios({
        url: `${baseURL}/statistic/print-merchants`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Händlerliste.xlsx`)
        document.body.appendChild(link)
        link.click()
        this.printingMerchants = false
      })
    },
    modelCount(model, models) {
      let count = 0
      const foundModels = models.filter(m => {
        return m.group === model.label
      })

      if (foundModels.length) {
        foundModels.forEach(m => {
          count += m.count
        })
      } else {
        count = model.count
      }

      return count
    },
    setMatomoSiteId() {
      if (this.config.tracking !== undefined) {
        this.$matomo.setSiteId(this.config.tracking.matomoSiteId)
        //console.log(this.$matomo.getSiteId())
      }
    },
    doTranslate(lang_pair) {
      const lang = lang_pair.split("|")[1];
      if (this.getCurrentLang == null && lang == lang_pair.split("|")[0]) return;
      let teCombo;
      var sel = document.getElementsByTagName("select");
      for (var i = 0; i < sel.length; i++)
        if (sel[i].className.indexOf("goog-te-combo") != -1) {
          teCombo = sel[i];
          break;
        }
      if (document.getElementById("google_translate_element2") == null || document.getElementById("google_translate_element2").innerHTML.length == 0 || teCombo.length == 0 || teCombo.innerHTML.length == 0) {
        setTimeout(() => {
          this.doTranslate(lang_pair);
        }, 500);
      } else {
        teCombo.value = lang;
        this.fireTranslateEvent(teCombo, "change");
        this.fireTranslateEvent(teCombo, "change");
      }
    },
    getCurrentLang() {
      var keyValue = document["cookie"].match("(^|;) ?googtrans=([^;]*)(;|$)");
      return keyValue ? keyValue[2].split("/")[2] : null;
    },
    fireTranslateEvent(element, event) {
      try {
        if (document.createEventObject) {
          const evt = document.createEventObject();
          element.fireEvent("on" + event, evt);
        } else {
          const evt2 = document.createEvent("HTMLEvents");
          evt2.initEvent(event, true, true);
          element.dispatchEvent(evt2);
        }
      } catch (e) {
        console.log(e);
      }
    }
  },

  computed: {
    ...mapGetters([
      'mode',
      'customerTypeLabel',
      'modeLabel',
      'modePriceLabel',
      'showEndcustomerPrices',
      'showMerchantPrices',
      'cartCount',
      'tenant',
      'makes',
      'stats',
      'config'
    ]),
    currentYear() {
      return new Date().getFullYear()
    },
    showCart() {
      if (this.config.general && this.config.general.disableCart) {
        return false
      }
      return true
    },
    logo() {
      if (this.mode === 'endcustomer' && this.$store.state.auth.user.data) {
        const merchantLogo = this.$store.state.auth.user.data.merchant.files.find(f => f.type === 'logo')
        if (merchantLogo) {
          return `${frontendUrl}/${merchantLogo.path}`
        }
      }
      return this.tenant.logo
    }
  }
}
</script>
